export const defaultMultiManagerPoweredByMessage =
  "Use your Juniper Square account to access investment information across different managers";

export const defaultSingleManagerPoweredByMessage = (arenaName?: string) =>
  arenaName
    ? `Sign in with your Juniper Square account to access your investment information.`
    : defaultMultiManagerPoweredByMessage;
